import React from 'react';

import AdobeIcon from './assets/adobe.svg';
import AlertLogicIcon from './assets/alert-logic.svg';
import CloudLinuxIcon from './assets/cloud-linux.svg';
import CybersicherheitIcon from './assets/cybersicherheit.svg';
import InavistieIcon from './assets/inavistie.svg';
import PlayrixIcon from './assets/playrix.svg';
import RingCentralIcon from './assets/ring-central.svg';
import SemrushIcon from './assets/semrush.svg';
import Soft2BetIcon from './assets/soft-2-bet.svg';
import VulcanIcon from './assets/vulcan.svg';
import CustomerItem from './components/CustomerItem';
import useStyles from './styles';

import Carousel from '../../../components/Carousel';

interface Props {
    className?: string;
    compact?: boolean;
}

const Customers: React.FC<Props> = ({ compact, className }) => {
    const { classes, cx } = useStyles();
    return (
        <Carousel className={cx(classes.carousel, className)} gap={20} direction="rtl">
            <CustomerItem compact={compact} logo={<AlertLogicIcon />} />
            <CustomerItem compact={compact} logo={<CloudLinuxIcon />} />
            <CustomerItem compact={compact} logo={<CybersicherheitIcon />} />
            <CustomerItem compact={compact} logo={<InavistieIcon />} />
            <CustomerItem compact={compact} logo={<PlayrixIcon />} />
            <CustomerItem compact={compact} logo={<RingCentralIcon />} />
            <CustomerItem compact={compact} logo={<SemrushIcon />} />
            <CustomerItem compact={compact} logo={<Soft2BetIcon />} />
            <CustomerItem compact={compact} logo={<AdobeIcon />} />
            <CustomerItem compact={compact} logo={<VulcanIcon />} />
        </Carousel>
    );
};

export default Customers;
